/* eslint-disable */
export default {
  noActiveCalls: 'No active calls',
  currentCall: 'Current Call',
  ringCall: 'Ringing call',
  onHoldCall: 'Call on Hold',
  otherDeviceCall: 'Ongoing calls on my other devices',
  confirmation: 'Confirmation',
  confirmMergeToConference: 'Add to conference call?',
  mergeToConference: 'Merge',
  conferenceCall: 'Conference Call',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
